import React, { ReactElement } from 'react';
import { Modal, Button, Row, Col } from 'antd';
import { GUTTOR_SPACE } from '../../shared/constants/commonConstants';
import ReconciliationFileUpload from '../crm/updates/ReconciliationFileUploadModal';
import { CheckCircleOutlined } from '@ant-design/icons';
import './ReconciliationTATReport/ReconciliationTATReport.less';

const UploadFileAlert = (props: any): ReactElement => {
  const {   isVisible, onButtonClick, onSuccess, isSuccess, updatedClaimNumbersCount, totalClaimCount } = props;
  return (
    <>
      <Modal
        title={!isSuccess ? 'Upload Report' : <><CheckCircleOutlined />&nbsp;Sucessfully Updated</>}
        visible={isVisible}
        className={!isSuccess ? 'upload-excel-model' : 'upload-excel-file-model'}
        closable={false}
        footer={null}
      >
        {!isSuccess ? <>
          <p className="alert-title">Alert!!</p>
          <p>Please don’t make any changes in the document name before uploading.</p>
          <Row gutter={GUTTOR_SPACE}>
            <Col md={24}> <div>
              <ReconciliationFileUpload
                onSuccess={onSuccess}
              />
              <Col md={6}  offset={18}>
                <Button
                className="w-100"
                onClick={(e: any): void => onButtonClick()}
                danger={true}
              >
                Close
              </Button>
            </Col>
              </div>
            </Col>
          </Row></> : <Row gutter={GUTTOR_SPACE} style={{ justifyContent: 'center', alignItems: 'center'}}>
          <Col md={16} className="messages-wrapper ">
            <p>{`${updatedClaimNumbersCount} / ${totalClaimCount} Claims have been updated in the system.`}</p>
            <p>You can view the details in the Timeline.</p>
          </Col>
          <Col md={18}>
            <Button
              type="primary"
              className="w-100"
              onClick={(e: any): void => onButtonClick()}
            >
              Okay
            </Button>
          </Col>
        </Row>}
      </Modal>
    </>
  );
};

export default UploadFileAlert;
